import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class CredentialStoresMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CredentialStoresMetaModule,
            providers: [
                providePageMeta({
                    title: 'Credential Stores',
                    translationKey: 'page_credentials',
                    routerLink: '/credential-stores',
                    permission: 'Settings.View',
                    type: 'Admin',
                    icon: 'security',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 3,
                }),
            ],
        };
    }
}
